export default {
  install(Vue) {
    Vue.prototype.$interpolate = (str, obj) => {
      const newStr = str;
      return newStr.replace(/\${(.*?)}/g, (x, g) => obj[g]);
    };
  }
};
